<template>
  <div class="document">
    <div class="header">
      <es-header>
        <template #header>
          <div class="header-title">
            Retire / Merge ID
          </div>
        </template>
      </es-header>
    </div>
    <div class="no-border-top">
      <div class="no-bottom-border">
        <es-form>
          <template #es-form>
            <div class="row removeUnderline">
              <div class="field is-horizontal">
                <div class="field-label is-normal">
                  <label
                    class="label"
                    id="retireLabel"
                  >
                    ID to Retire
                  </label>
                </div>
                <div class="field-body">
                  <div class="field">
                    <div class="control">
                      <input
                        type="text"
                        class="input"
                        v-model="retireId"
                        @keypress="isWholeNumbers($event)"
                        :class="{'is-danger' : hasErrorRetireId}"
                        aria-labelledby="retireLabel"
                      >
                    </div>
                    <span
                      v-if="hasErrorRetireId"
                      class="help is-danger"
                    >
                      {{ msgErrorRetireId }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row removeUnderline">
              <div class="field is-horizontal">
                <div class="field-label is-normal">
                  <label
                    class="label"
                    id="mergeLabel"
                  >
                    ID to Merge to
                  </label>
                </div>
                <div class="field-body">
                  <div class="field">
                    <div class="control">
                      <input
                        type="text"
                        class="input"
                        v-model="mergeId"
                        @keypress="isWholeNumbers($event)"
                        :class="{'is-danger' : hasErrorMergeId}"
                        aria-labelledby="mergeLabel"
                      >
                    </div>
                    <span
                      v-if="hasErrorMergeId"
                      class="help is-danger"
                    >
                      {{ msgErrorMergeId }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </es-form>
      </div>
    </div>
    <div
      class="is-flex flex-justify--end flex-align--center"
      style="margin-right: 5.15rem; padding-bottom: 2rem"
    >
      <button
        class="button button-link has-underline"
        @click="reset"
        style="margin-right: 1rem"
      >
        Reset
      </button>
      <button
        class="button is-primary"
        @click="submitIds"
      >
        Submit
      </button>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import EsForm from '@/components/EsForm.vue';
import EsHeader from '@/components/EsHeader.vue';
import NotificationManager from '@/mixins/NotificationManager';

export default {
  mixins: [
    NotificationManager,
  ],
  components: {
    EsForm,
    EsHeader,
  },
  watch: {
    mergeIdLength() {
      if (this.mergeIdLength > 25) {
        this.hasErrorMergeId = true;
        this.msgErrorMergeId = '\'ID to Merge to\' allows a maximum of 25 characters.';
      } else {
        this.hasErrorMergeId = false;
        this.msgErrorMergeId = null;
      }
    },
    retireIdLength() {
      if (this.retireIdLength > 25) {
        this.hasErrorRetireId = true;
        this.msgErrorRetireId = '\'ID to Retire\' allows a maximum of 25 characters.';
      } else {
        this.hasErrorRetireId = false;
        this.msgErrorRetireId = null;
      }
    },
  },
  data() {
    return this.initialData();
  },
  computed: {
    idToMerge() {
      const temp = {};
      const mergeIdArray = [];
      if (this.mergeId) {
        temp.personId = this.mergeId;
        temp.decision = 'merge';
        mergeIdArray.push(temp);
      }
      return mergeIdArray;
    },
    idToRetire() {
      const temp = {};
      const retireIdArray = [];
      if (this.retireId) {
        temp.personId = this.retireId;
        temp.decision = 'retire';
        retireIdArray.push(temp);
      }
      return retireIdArray;
    },
    idsForComparePage() {
      return this.idToMerge.length ? this.idToRetire.concat(this.idToMerge) : this.idToRetire;
    },
    mergeIdLength() {
      if (this.idToMerge.length) {
        return this.idToMerge[0].personId.length;
      } return 0;
    },
    retireIdLength() {
      if (this.idToRetire.length) {
        return this.idToRetire[0].personId.length;
      } return 0;
    },
    setOfUserDistricts() {
      return this.$store.state.user.locationPermissions[0].districts.map(a => a.code);
    },
    setOfUserPersonTypes() {
      return this.$store.state.user.userPersonTypes.map(a => a.personTypeCode);
    },
    setOfUserSchools() {
      return this.$store.state.user.locationPermissions[0].schools.map(a => a.code);
    },
  },
  methods: {
    initialData() {
      return {
        formErrorMsg: 'There were some errors. Please fix the errors highlighted in the fields below.',
        hasErrorMergeId: false,
        hasErrorRetireId: false,
        mergeId: null,
        msgErrorRetireId: null,
        retireId: null,
      };
    },
    isWholeNumbers(evt) {
      // Listen to the key event when a keyboard key is pressed
      evt = (evt) || window.event; // eslint-disable-line
      // Store the ASCII value of the pressed key in 'charCode'
      const charCode = (evt.which) ? evt.which : evt.keyCode;
      // Prevent user from entering any values except digits
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 83) {
        evt.preventDefault();
      }
    },
    reset() {
      this.retireId = null;
      this.mergeId = null;
      this.hasErrorRetireId = false;
      this.msgErrorRetireId = null;
      this.hasErrorMergeId = false;
      this.msgErrorMergeId = null;
      this.resetNotifications();
    },
    resetNotifications() {
      this.$store.state.notifications.isActive = false;
      this.$store.state.notifications.notificationType = null;
    },
    showError(error) {
      this.showNotification('danger', [error]);
    },
    async submitIds() {
      this.hasErrorRetireId = false;
      this.msgErrorRetireId = null;
      this.hasErrorMergeId = false;
      this.msgErrorMergeId = null;
      this.resetNotifications();
      if (!this.retireId) {
        this.hasErrorRetireId = true;
        this.msgErrorRetireId = '\'ID to Retire\' is required.';
        this.showError(this.formErrorMsg);
      } else if (this.retireId === this.mergeId) {
        this.hasErrorRetireId = true;
        this.msgErrorRetireId = '\'ID to Retire\' should not be same as \'ID to Merge\'.';
        this.hasErrorMergeId = true;
        this.msgErrorMergeId = '\'ID to Merge\' should not be same as \'ID to Retire\'.';
        this.showError(this.formErrorMsg);
      } else {
        this.retireId = this.retireId.trim();
        this.retireId = this.retireId.replace(/[-/ /]/g, '');
        if (this.mergeId) {
          this.mergeId = this.mergeId.trim();
          this.mergeId = this.mergeId.replace(/[-/ /]/g, '');
        }
        try {
          const retireResults = await axios.post(`person-search/by-id`, {
              idType: 'statePersonId',
              id: this.retireId,
            });
          if (retireResults.status === 200) {
            if (!retireResults.data.data.length) {
              this.hasErrorRetireId = true;
              this.msgErrorRetireId = 'The \'ID to Retire\' not found.';
              this.showNotification('danger', ['The \'ID to Retire\' not found.']);
            } else {
              [this.retirePerson] = retireResults.data.data;
              if (this.retirePerson.retired) {
                this.hasErrorRetireId = true;
                this.msgErrorRetireId = 'The \'ID to Retire\' is already Retired.';
                this.showNotification('danger', ['The \'ID to Retire\' is already Retired.']);
              }
              const hasUserDistrictAccess = this.setOfUserDistricts.length === 0
                || this.setOfUserDistricts.includes(this.retirePerson.districtCode);
              const hasUserSchoolAccess = this.setOfUserSchools.length === 0
                || this.setOfUserSchools.includes(this.retirePerson.schoolCode);
              const hasUserPersonTypeAccess = this.setOfUserPersonTypes.length === 0
                || this.setOfUserPersonTypes.includes(this.retirePerson.personType);
              if (!hasUserDistrictAccess) {
                this.hasErrorRetireId = true;
                this.msgErrorRetireId = `User is not authorized to submit records to the specified district : ${this.retirePerson.districtCode}`;
                this.showError(this.msgErrorRetireId);
              } else if (!hasUserSchoolAccess) {
                this.hasErrorRetireId = true;
                this.msgErrorRetireId = `User is not authorized to submit records to the specified school : ${this.retirePerson.schoolCode}`;
                this.showError(this.msgErrorRetireId);
              } else if (!hasUserPersonTypeAccess) {
                this.hasErrorRetireId = true;
                this.msgErrorRetireId = `User is not authorized to submit records to the specified person type : ${this.retirePerson.personType}`;
                this.showError(this.msgErrorRetireId);
              } else {
                const sort = [{
                  field: 'lastUpdateDate',
                  order: 'DESC',
                }];
                const params = new URLSearchParams();
                params.append('pageSize', '12');
                params.append('sort', JSON.stringify(sort));
                if (this.mergeId) {
                  const mergeResults = await axios.post(`person-search/by-id`, {
                      idType: 'statePersonId',
                      id: this.mergeId,
                    });
                  if (mergeResults.status === 200) {
                    if (!mergeResults.data.data.length) {
                      this.hasErrorMergeId = true;
                      this.msgErrorMergeId = 'The \'ID to Merge to\' not found.';
                      this.showNotification('danger', ['The \'ID to Merge to\' not found.']);
                    } else {
                      [this.mergePerson] = mergeResults.data.data;
                      if (this.mergePerson.retired) {
                        this.hasErrorMergeId = true;
                        this.msgErrorMergeId = 'The \'ID to Merge to\' is already Retired.';
                        this.showNotification('danger', ['The \'ID to Merge to\' is already Retired.']);
                      } else {
                        this.hasErrorRetireId = false;
                        this.msgErrorRetireId = null;
                        this.hasErrorMergeId = false;
                        this.msgErrorMergeId = null;
                        this.resetNotifications();
                        this.$router.push({
                          name: 'PIRetireMergeDetails',
                          query: { retireId: this.retireId, mergeId: this.mergeId },
                        });
                      }
                    }
                  }
                } else {
                  this.hasErrorRetireId = false;
                  this.msgErrorRetireId = null;
                  this.hasErrorMergeId = false;
                  this.msgErrorMergeId = null;
                  this.resetNotifications();
                  this.$router.push({
                    name: 'PIRetireMergeDetails',
                    query: { retireId: this.retireId },
                  });
                }
              }
            }
          }
        } catch (err) {
          this.loadingError = true;
        } finally {
          this.loading = false;
        }
      }
    },
  },
};
</script>

<style lang="sass" scoped>
</style>
